import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 24 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M23.185 7.196c-.032-.074-.827-1.835-2.592-3.6C18.241 1.242 15.27 0 12 0S5.76 1.243 3.407 3.595C1.642 5.361.844 7.125.815 7.196a.75.75 0 0 0 0 .61c.032.074.827 1.834 2.592 3.6C5.759 13.756 8.73 15 12 15s6.24-1.243 8.593-3.594c1.765-1.766 2.56-3.526 2.592-3.6a.75.75 0 0 0 0-.61M12 13.5c-2.886 0-5.407-1.05-7.493-3.117A12.5 12.5 0 0 1 2.344 7.5a12.5 12.5 0 0 1 2.163-2.883C6.593 2.55 9.114 1.5 12 1.5s5.407 1.05 7.493 3.117A12.5 12.5 0 0 1 21.661 7.5c-.676 1.262-3.62 6-9.661 6M12 3a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m0 7.5a3 3 0 1 1 0-5.999 3 3 0 0 1 0 5.999" }, null, -1)
  ])))
}
export default { render: render }